// @flow
import * as React from 'react'
import { constants } from 'mz-sdk'
import Icon from 'app/components/base/Icon'
import style from './style.css'

const TripCategory = ({ categoryName, vehicleTypeName }) => (
  <div className={style.container}>
    <Icon
      family="mozio"
      name={constants.CATEGORIES_FILTERS[categoryName]}
      className={style.icon}
    />
    <div className={style.categoryName}>
      {vehicleTypeName || ''}
    </div>
  </div>
)

export default TripCategory